import uuid from '../../utils/uuid'

const STATS_KEY = 'fixBadCharactersStats'

export interface MockRecord {
  dpid: string
  namePrefix: string
  nameGiven: string
  nameFamily: string
  nameSuffix: string
  reason?: string
}

export interface BatchRecord extends MockRecord {
  id: string
  selectedType?: 'SUBMITTED' | 'SKIPPED'
  savedData?: {
    namePrefix: string
    nameGiven: string
    nameFamily: string
    nameSuffix: string
    reason: string
  } | null
}

export interface BatchResult {
  corrected: number
}

function shuffleArray<T>(array: T[]): T[] {
  const result = [...array]
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }
  return result
}

export async function checkoutBatch(count = 10): Promise<BatchRecord[]> {
  const { default: mockData } = await import('./mockData.json')
  const shuffled = shuffleArray(mockData as MockRecord[])
  const batch: BatchRecord[] = shuffled.slice(0, count).map((record) => ({
    ...record,
    id: uuid(),
  }))
  return batch
}

export function submitBatch(batch: BatchRecord[]): Promise<BatchResult> {
  const corrected = batch.filter((item) => item.selectedType === 'SUBMITTED').length
  const current = Number.parseInt(sessionStorage.getItem(STATS_KEY) || '0', 10)
  sessionStorage.setItem(STATS_KEY, String(current + corrected))
  return Promise.resolve({ corrected })
}

export function getStats(): { namesCorrected: number } {
  const namesCorrected = Number.parseInt(sessionStorage.getItem(STATS_KEY) || '0', 10)
  return { namesCorrected }
}
